module.exports = __webpack_public_path__ + "static/img/第十五届.7b4424e.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第十五届.png
// module id = cSHQ
// module chunks = 1